import { render, staticRenderFns } from "./get-code.vue?vue&type=template&id=4a8ee7a6&scoped=true&"
import script from "./get-code.js?vue&type=script&lang=js&"
export * from "./get-code.js?vue&type=script&lang=js&"
import style0 from "./get-code.scss?vue&type=style&index=0&id=4a8ee7a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8ee7a6",
  null
  
)

export default component.exports